import AuthService from '../../utilities/services/auth.service'
import { SalesVelocityWrapper } from '../../components'

export default function SalesVelocityPage() {
  const organization = AuthService.getOrg()[0]

  return <SalesVelocityWrapper organization={organization} />
}
